import { all, call } from "redux-saga/effects";
import authRootSaga from "./Auth";

export default function* rootSaga() {
   yield all([call(authRootSaga)]);
}
